export default __webpack_public_path__ + "static/media/CL01.8ca3485b.mp3";